
export const createGroupPostId = () => {
    const milliseconds = Date.now();
    const uniqueFourDigits = Math.floor(1000 + Math.random() * 9000);
    return parseInt(`${milliseconds}${uniqueFourDigits}`).toString(16);
}

